import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { applyUpdate, postponeUpdate, useUpdateAvailable, useUpdatePostponed } from '../../lib/pwa';

/** Floating card offered after a deploy; reloading is the user's choice, never forced. */
export function UpdatePrompt() {
  const { t } = useTranslation('common');
  const available = useUpdateAvailable();
  const postponed = useUpdatePostponed();

  // Deferred: the UpdateBanner keeps the offer on screen, the card gets out of the way.
  if (!available || postponed) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-[100] flex justify-center px-4 pb-[env(safe-area-inset-bottom)]" role="status" aria-live="polite">
      <div className="pointer-events-auto flex w-full max-w-md flex-col gap-2 rounded-2xl border border-border bg-card px-4 py-3 text-sm text-foreground shadow-lg sm:w-auto sm:flex-row sm:items-center sm:gap-3 sm:rounded-full sm:py-2 sm:pl-4 sm:pr-2">
        <div className="flex items-center gap-2 sm:contents">
          <RefreshCw className="h-4 w-4 shrink-0 text-primary" aria-hidden />
          <span className="font-medium">{t('update.available')}</span>
        </div>
        <div className="flex items-center justify-end gap-2 sm:contents">
          <button type="button" onClick={postponeUpdate} className="h-11 rounded-full px-4 text-xs text-muted-foreground hover:text-foreground sm:h-auto sm:px-2 sm:py-1">
            {t('update.later')}
          </button>
          <button type="button" onClick={applyUpdate} className="h-11 rounded-full bg-primary px-5 text-xs font-medium text-primary-foreground hover:opacity-90 sm:h-auto sm:px-3 sm:py-1.5">
            {t('update.now')}
          </button>
        </div>
      </div>
    </div>
  );
}
